import { Job } from '@applicator/shared'

// Handle sort
export function handleSort(
  column: string,
  sortColumn: string | null,
  sortDirection: 'asc' | 'desc',
  setSortColumn: React.Dispatch<React.SetStateAction<string | null>>,
  setSortDirection: React.Dispatch<React.SetStateAction<'asc' | 'desc'>>
) {
  if (sortColumn === column) {
    // Toggle direction if same column
    setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc')
  } else {
    // New column, start with ascending
    setSortColumn(column)
    setSortDirection('asc')
  }
}

// Handle prepare click
export function handlePrepareClick(jobIds: string[], navigate: (path: string) => void) {
  if (jobIds.length === 1) {
    navigate(`/prepare/${jobIds[0]}`)
  } else {
    navigate(`/prepare?jobIds=${jobIds.join(',')}`)
  }
}

// Get selected job IDs
export function getSelectedJobIds(selectedRows: Set<number>, sortedFilteredJobs: Job[]): Set<string> {
  return new Set(
    Array.from(selectedRows).map((index) => {
      const job = sortedFilteredJobs[index]
      return job?.id || ''
    }).filter(Boolean)
  )
}
